import { render, staticRenderFns } from "./RestartModal.vue?vue&type=template&id=2ca3871c&"
import script from "./RestartModal.vue?vue&type=script&lang=js&"
export * from "./RestartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports